import { React, Component, Container, _, Icon } from 'utils';
import { MoveStore, Creators } from 'model';

class Move extends Component {
	
	static getStores() {
		return [MoveStore]
	}

	static calculateState() {
		return MoveStore.getState();
	}

	handleClick = () => {
		Creators.moveDone();
	}
	
	render() {
		var { inProgress, resumes, folder, resumesExist } = this.state;

		if(folder != null) {
			var css = 'alert ';
			var msg = '';
			var icon = '';

			if(inProgress) {
				css += 'alert-info';
				msg = <span>{ _('Prebacujem ')} <strong>{resumes.length}</strong> {_('životopisa u')} <strong>{ folder.title }</strong> </span>;
				icon = 'hourglass';
				var progress = 	<div className={css}>
									<Icon name={icon} /> {msg}
								</div>

			}
			else if(resumes.length > 0 && !inProgress)
			{

				var msgSuccess = <span className="msg-status">{ _('Prebačeno u ')} <strong>{ folder.title }</strong> <strong>{resumes.length}</strong> {_('profil')}</span>;
				if(resumes.length > 1){
					msgSuccess = <span className="msg-status">{ _('Prebačeno u ')} <strong>{ folder.title }</strong> <strong>{resumes.length}</strong> {_('profila')}</span>;
				}
				var successMsg = <div className="box-message">
					<span className="glyphicon glyphicon-thumbs-up message-succ"></span>
					{msgSuccess}
				</div>;

			}

			if(resumesExist.length > 0){
				var msgError = <span className="msg-status">{ _('U mapi već postoji ')} <strong>{resumesExist.length}</strong> {_('profil s liste.')}</span>
				if(resumesExist.length > 1){
					msgError = <span className="msg-status">{ _('U mapi već postoje ')} <strong>{resumesExist.length}</strong> {_('profila s liste.')}</span>
				}
				var errorMsg = <div className="box-message">
					<span className="glyphicon glyphicon-thumbs-down message-err"></span>
					{msgError}
				</div>;
			}

			return <div>
				{progress}
				{successMsg}
				{errorMsg}
			</div>
		} else {
			return <div></div>;
		}
	}
}

const MoveContainer = Container.create(Move);
export default MoveContainer;


// WEBPACK FOOTER //
// ./src/modules/app/resumes/move.js